(function () {
  function initSpecSelector(root) {
    var buttons = root.querySelectorAll('[data-spec-button]');
    var panels = root.querySelectorAll('[data-spec-panel]');
    var indicator = root.querySelector('[data-spec-indicator]');
    var buttonsWrap = root.querySelector('[data-spec-buttons]');
    if (!buttons.length || !panels.length) return;

    function moveIndicator(button) {
      if (!indicator || !buttonsWrap) return;
      var wrapRect = buttonsWrap.getBoundingClientRect();
      var btnRect = button.getBoundingClientRect();
      indicator.style.transform = 'translateY(' + (btnRect.top - wrapRect.top) + 'px)';
      indicator.style.height = btnRect.height + 'px';
      indicator.classList.add('is-visible');
    }

    function activate(button) {
      var targetId = button.getAttribute('data-target');
      var targetPanel = root.querySelector('#' + CSS.escape(targetId));
      if (!targetPanel) return;

      buttons.forEach(function (b) { b.classList.remove('is-active'); });
      button.classList.add('is-active');

      panels.forEach(function (p) {
        p.classList.remove('is-active', 'is-animating');
      });

      targetPanel.classList.add('is-active');
      // Force reflow so the animation replays every time a new panel is shown.
      void targetPanel.offsetWidth;
      targetPanel.classList.add('is-animating');

      moveIndicator(button);
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        activate(button);
      });
    });

    moveIndicator(buttons[0]);
    window.addEventListener('resize', function () {
      var active = root.querySelector('[data-spec-button].is-active');
      if (active) moveIndicator(active);
    });
  }

  document.querySelectorAll('[data-a2k-spec-selector]').forEach(initSpecSelector);
})();
